<template>
    <div>
        <el-table
            v-loading="loading"
            :data="list"
            :header-cell-style="{background:'#d1e1ff','font-size':'12px'}"
            size="mini"
            :empty-text="datasrow.ad_min_name_tag == 0 ? '数据尚未读取完成，请等待完成后再点击获取列表数据！' : '暂无数据'"
            ref="multipleTables">
            <el-table-column
                label="广告组合名称"
                align="center"
                width="200">
                <template slot-scope="scope">
                    <span style="word-break: break-word !important;">{{ scope.row.ad_min_name }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="大词建议竞价"
                align="center"
                width="120">
                <template slot-scope="scope">
                    <span style="word-break: break-word !important;">{{ scope.row.suggest_bidding }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="目标acos"
                align="center"
                width="150">
                <template slot-scope="scope">
                    <span style="word-break: break-word !important;">{{ scope.row.target_acos }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="词根"
                align="center"
                min-width="200">
                <template slot-scope="scope">
                    <el-tag v-for="(item, i) in scope.row.manual_root" :key="i" style="margin: 5px 10px 5px 0;">{{ item }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                width="250"
                align="center"
                label="操作">
                <template slot-scope="scope">
                    <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click.native="on_updata(scope.row)">更新数据</el-button>
                    <el-button v-if="scope.row.file_path" style="margin: 5px 0 5px 10px" type="primary" size="mini" @click.native="download_file_manual(scope.row)">广告分组数据分析下载</el-button>
                </template>
            </el-table-column>
        </el-table>
        <add-manual ref="addManual" :visible="ctrl.AddManualVisible" :record_id="record_id" :title="'录入广告组合名称数据'" @close-callback="closeCllback"></add-manual>
    </div>
</template>
<script>
import * as api from "@/api/adv/adv";
import AddManual from "./addManual.vue";
import { binary_download } from "@/utils/method";
export default {
    components: { AddManual },
    props: {
        datasrow: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            ctrl: {
                AddManualVisible: false
            },
            loading: false,
            list: [],
            record_id: 0,
            query: {
                page: 1,
                limit: 20
            },
            filter: {},
            formData: {}
        };
    },
    methods: {
        getList() {
            let obj = {};
            obj.record_id = this.datasrow.id;
            this.loading = true;
            api.get_ad_min_name_list(obj)
                .then(async res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //下载文件
        download_file_manual(data) {
            binary_download(
                "/apis/ad_data_analysis/ad_min_name_file_download",
                "post",
                {},
                {
                    record_id: data.id,
                    ad_min_name: data.ad_min_name
                },
                "application/vnd.ms-excel",
                `${data.ad_min_name} 合理性数据分析.xlsx`
            );
        },
        on_updata(data) {
            let obj = {
                ad_min_name: data.ad_min_name,
                suggest_bidding: data.suggest_bidding,
                ad_search_word_id: data.ad_search_word_id,
                target_acos: data.target_acos,
                manual_root:
                    data.manual_root == null
                        ? null
                        : data.manual_root.join("\n")
            };
            this.$refs.addManual.onData(obj);
            this.ctrl.AddManualVisible = true;
            this.record_id = data.id;
            // let obj = {};
            // obj.ad_min_name_list = data;
            // this.loading = true;
            // api.update_ad_min_name_list(obj)
            //     .then(async res => {
            //         this.loading = false;
            //         if (res.code === 0) {
            //             this.list = res.data;
            //         } else {
            //             this.$message({
            //                 type: "error",
            //                 message: res.message
            //             });
            //         }
            //     })
            //     .catch(() => {
            //         this.loading = false;
            //     });
        },
        on_add_manual_root(data) {
            let arr = [];
            if (data.manual_root.length == 0) {
                arr = [
                    {
                        ad_mix_name: "",
                        manual_root: ""
                    }
                ];
            } else {
                let data = data.manual_root;
                for (let i = 0; i < data.length; i++) {
                    arr.push({
                        ad_mix_name: data[i].ad_mix_name,
                        manual_root: data[i].manual_root.join("\n")
                    });
                }
            }
            this.$refs.addManual.onData(arr);
            this.ctrl.AddManualVisible = true;
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.AddManualVisible = false;
            if (isshow) return;
            this.getList();
        }
    }
};
</script>
<style type="text/scss" lang="scss">
.el-tooltip__popper {
    max-width: 300px !important;
}
</style>
<style type="text/scss" lang="scss" scoped>
.pen {
    cursor: pointer;
}
.pen:hover {
    text-decoration: underline;
}
.line {
    display: inline-block;
}
/deep/ .el-divider--horizontal {
    margin: 8px 0 4px 0 !important;
}
.filter-block {
    background-color: #a9c7ff;
    padding: 6px 6px 6px 10px;
    font-size: 18px;
    color: #333;
    margin: 0;
    display: flex;
    // justify-content: space-between;
    align-items: center;
}
.filter-block-left {
    display: flex;
    align-items: center;
}
/deep/ .el-table--border {
    border: none;
}
</style>
